import { Extension } from "@tiptap/core";
import { PluginKey } from "@tiptap/pm/state";
import Suggestion from "@tiptap/suggestion";
import { type DocLinkItem, getHost } from "./host";
import { filterSlashItems, type SlashItem } from "./slash-items";
import { createSuggestionStore, type SuggestionStore, storeRenderer } from "./suggestion-store";

export const SlashCommand = Extension.create<{ store: SuggestionStore<SlashItem> }>({
  name: "klaritySlash",
  addOptions() {
    return { store: createSuggestionStore<SlashItem>() };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion<SlashItem, SlashItem>({
        editor: this.editor,
        pluginKey: new PluginKey("klaritySlash"),
        char: "/",
        items: ({ query, editor }) => filterSlashItems(query, editor),
        command: ({ editor, range, props }) => {
          editor.chain().focus().deleteRange(range).run();
          Promise.resolve(props.run(editor)).catch(() => {});
        },
        render: storeRenderer(this.options.store),
      }),
    ];
  },
});

export const DocLinkSuggest = Extension.create<{ store: SuggestionStore<DocLinkItem> }>({
  name: "klarityDocLinks",
  addOptions() {
    return { store: createSuggestionStore<DocLinkItem>() };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion<DocLinkItem, DocLinkItem>({
        editor: this.editor,
        pluginKey: new PluginKey("klarityDocLinks"),
        char: "@",
        debounce: 150,
        items: async ({ query, editor }) =>
          query.trim() === "" ? [] : (await getHost(editor).searchDocs(query.trim())).slice(0, 8),
        command: ({ editor, range, props }) => {
          editor
            .chain()
            .focus()
            .insertContentAt(range, [
              { type: "docLink", attrs: { code: props.code, text: props.title } },
              { type: "text", text: " " },
            ])
            .run();
        },
        render: storeRenderer(this.options.store),
      }),
    ];
  },
});
